"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeMagentoServices = void 0;
const ordersServiceImpl_1 = require("../magento/orders/ordersServiceImpl");
const initializeMagentoServices = (services) => {
    services.magento.ordersService = new ordersServiceImpl_1.OrdersServiceImpl(services.proxy.proxyService);
};
exports.initializeMagentoServices = initializeMagentoServices;
//# sourceMappingURL=magentoModule.js.map